import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  align: {
    paddingTop: '9px !important',
  },
  emptyIcon: {
    width: '20px !important',
  },
  required: {
    '&::after': {
      content: '"*"',
      color: 'red',
      marginLeft: '4px',
    },
  },
});
